module.exports = __webpack_public_path__ + "media/images/pages/about_us/partners/logo_eticoop-43391e7e43d0e2aa040d69e7e463a599.png";